module.exports = __webpack_public_path__ + "static/business-plan-7682b8dbb6765e700fba6e65f8b5f1e1.jpg";